import { useMemo } from "react"

type EmptyObject = { [x: string]: undefined }

export function useComputedIfNotNull<T, R>(value: T | undefined | null, fn: (_: T) => R): R | EmptyObject {
  return useMemo(() => {
    if (!value) {
      return {}
    }
    return fn(value)
  }, [value])
}
